export const sum = (arr: number[]) => arr.reduce((acc, n) => acc + n, 0);